<template>
  <form class="create-account-form" @submit.prevent="onSubmit">
    <dx-form :form-data="formData" :disabled="loading">
      <dx-item
        data-field="username"
        editor-type="dxTextBox"
        :editor-options="{ stylingMode: 'filled', placeholder: 'username (login)', mode: 'text' }"
      >
        <dx-required-rule message="A Username (login name) is required to continue" />
        <dx-label :visible="false" />
      </dx-item>
      <dx-item
        data-field="name"
        editor-type="dxTextBox"
        :editor-options="{ stylingMode: 'filled', placeholder: 'name', mode: 'text' }"
      >
        <dx-label :visible="false" />
      </dx-item>
      <dx-item
        data-field="lastName"
        editor-type="dxTextBox"
        :editor-options="{ stylingMode: 'filled', placeholder: 'last name', mode: 'text' }"
      >
        <dx-label :visible="false" />
      </dx-item>
      <dx-item
        data-field="password"
        editor-type="dxTextBox"
        :editor-options="{ stylingMode: 'filled', placeholder: 'password', mode: 'password' }"
      >
        <dx-required-rule message="Password is required to continue" />
        <dx-label :visible="false" />
      </dx-item>
      <dx-item
        data-field="confirmedPassword"
        editor-type="dxTextBox"
        :editor-options="{ stylingMode: 'filled', placeholder: 'password confirmation', mode: 'password' }"
      >
        <dx-required-rule message="Password confirmation is required" />
        <dx-custom-rule
          message="Password and confirmation are different"
          :validation-callback="confirmPassword"
        />
        <dx-label :visible="false" />
      </dx-item>
      <dx-item>
        <template #default>
          <div class='policy-info'>
            <!-- TODO: privacy policy and terms of service links and pages in router -->
            When creating an account you accept the <router-link to="#">Terms of Service</router-link> and the <router-link to="#">Privacy Policy</router-link> for this application 
          </div>
        </template>
      </dx-item>
      <dx-button-item>
        <dx-button-options
          width="100%"
          type="default"
          template="createAccount"
          :use-submit-behavior="true"
        >
        </dx-button-options>
      </dx-button-item>
      <template #createAccount>
        <div>
          <span class="dx-button-text">
              <dx-loadIndicator v-if="loading" width="24px" height="24px" :visible="true" />
              <span v-if="!loading">Create User</span>
          </span>
        </div>
      </template>
    </dx-form>
  </form>
</template>

<script>
import DxForm, {
  DxItem,
  DxLabel,
  DxButtonItem,
  DxButtonOptions,
  DxCustomRule,
  DxRequiredRule,
} from 'devextreme-vue/form';
import DxLoadIndicator from 'devextreme-vue/load-indicator';
import notify from 'devextreme/ui/notify';
//import { useRouter } from 'vue-router';
import { ref, reactive } from 'vue';

import auth from "../services/auth";

export default {
  components: {
    DxForm,
    DxItem,
    DxLabel,
    DxButtonItem,
    DxButtonOptions,
    DxRequiredRule,
    DxCustomRule,
    DxLoadIndicator
  },
  emits: ['user-update'],
  setup(props, { emit }) {
    //const router = useRouter();
    
    const loading = ref(false);
    const formData = reactive({
      name:"",
      lastName:"",
      username:"",
      email:"",
      password:""
    });

    const onSubmit = async () => {
      //const { email, password } = formData;
      loading.value = true;
       try{
        const result = await auth.createLocalUser(formData);
        if (result.isOk) {
          notify('Account created Successfully!', 'success', 2000);
          emit('user-update', { username: formData.username, type:'create' });
          formData.name="";
          formData.lastName="";
          formData.username="";
          formData.password="";
        } else {
          notify(result.message||'unknown error', 'error', 2000);
        }
      }
      catch(e) {
        notify(e.message||'unknown error', 'error', 2000);
      }
      loading.value = false;
    };

    function confirmPassword(e) {
      return e.value === formData.password;
    }
    
    return {
        formData,
        loading,
        onSubmit,
        confirmPassword
    }
  }
}
</script>

<style lang="scss">
@import "../themes/generated/variables.base.scss";

.create-account-form {
  .policy-info {
    margin: 10px 0;
    color: rgba($base-text-color, alpha($base-text-color) * 0.7);
    font-size: 14px;
    font-style: normal;

    a {
      color: rgba($base-text-color, alpha($base-text-color) * 0.7);
    }
  }

  .login-link {
    color: $base-accent;
    font-size: 16px;
    text-align: center;
  }
}
</style>
